<template lang="html">
  <div class="main" v-if="show.other.type==='workspace'">
    <div class="name">
      <div class="title">{{show.other.spaceName}}</div>
      <i class="material-icons close" @click="close">close</i>
    </div>
    <div class="menu">
      <el-tabs v-model="activeName" @tab-click="chooseTab">
        <el-tab-pane name="0" :label="message.Sl124"></el-tab-pane>
        <el-tab-pane name="1" :label="message.Sl140"></el-tab-pane>
        <el-tab-pane name="2" :label="message.Sl166" v-if="show.other.role!==2"></el-tab-pane>
        <el-tab-pane name="3" :label="message.Sl191" v-if="show.other.role!==2"></el-tab-pane>
      </el-tabs>
    </div>
    <VuePerfectScrollbar @settings="settings" class="box">
      <comp-spaceinfo
        :id='show.other.id'
        :role='show.other.role'
        v-if="show.other.name==='workspaceInfo'"
      ></comp-spaceinfo>
      <comp-spacemembers
        :id='show.other.id'
        :role='show.other.role'
        v-if="show.other.name==='workspaceMembers'"
      ></comp-spacemembers>
      <comp-spacesettings
        :id='show.other.id'
        :role='show.other.role'
        v-if="show.other.name==='workspaceSettings'"
      ></comp-spacesettings>
      <comp-spacerecord
        :id='show.other.id'
        :role='show.other.role'
        v-if="show.other.name==='workspaceRecord'"
      ></comp-spacerecord>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import CompSpaceinfo from '@/components/other/workspace/info.vue'
import CompSpacemembers from '@/components/other/workspace/members.vue'
import CompSpacesettings from '@/components/other/workspace/settings.vue'
import CompSpacerecord from '@/components/other/workspace/record.vue'
export default {
  computed: {
    ...mapGetters({
      show: 'show'
    })
  },
  components: {
    CompSpaceinfo,
    CompSpacemembers,
    CompSpacesettings,
    CompSpacerecord,
    VuePerfectScrollbar
  },
  data () {
    return {
      message: {
        Sl124: this.$lang.ui.system.l124,
        Sl140: this.$lang.ui.system.l140,
        Sl166: this.$lang.ui.system.l166,
        Sl191: this.$lang.ui.system.l191
      },
      settings: {
        maxScrollbarLength: 0
      },
      activeName: '0'
    }
  },
  mounted () {
    if (this.show.other.type !== 'workspace') {
      return
    }
    if (this.show.other.name === 'workspaceInfo') {
      var name = '0'
    }
    if (this.show.other.name === 'workspaceMembers') {
      name = '1'
    }
    if (this.show.other.name === 'workspaceSettings') {
      name = '2'
    }
    if (this.show.other.name === 'workspaceRecord') {
      name = '3'
    }
    this.activeName = name
  },
  methods: {
    close () {
      this.$store.dispatch('showOther', '')
    },
    chooseTab () {
      var val = parseInt(this.activeName)
      this.showa(val)
    },
    showa (type) {
      var data = [
        {
          role: this.show.other.role,
          type: 'workspace',
          spaceName: this.show.other.spaceName,
          name: 'workspaceInfo',
          id: this.show.other.id
        },
        {
          role: this.show.other.role,
          type: 'workspace',
          spaceName: this.show.other.spaceName,
          name: 'workspaceMembers',
          id: this.show.other.id
        },
        {
          role: this.show.other.role,
          type: 'workspace',
          spaceName: this.show.other.spaceName,
          name: 'workspaceSettings',
          id: this.show.other.id
        },
        {
          role: this.show.other.role,
          type: 'workspace',
          spaceName: this.show.other.spaceName,
          name: 'workspaceRecord',
          id: this.show.other.id
        }
      ]
      this.$store.dispatch('showOther', data[type])
    }
  }
}
</script>

<style scoped lang="css">
.main {
  position: fixed;
  top: 10%;
  width: 840px;
  left: 50%;
  height: 85%;
  max-height: 680px;
  margin-left: -420px;
  background-color: #f0f0f0;
  -webkit-box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
  border-radius: 4px;
}
.name {
  width: 100%;
  height: 50px;
}
.menu {
  height: 40px;
  width: 100%;
  padding: 0 40px;
}
.close {
  float: right;
  margin: 11px;
  margin-right: 18px;
  cursor: pointer;
}
.left {
  float: left;
  margin: 11px;
  margin-right: 18px;
  cursor: pointer;
}
.title {
  display: block;
  height: 100%;
  line-height: 50px;
  float: left;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 600;
}
.box {
  position: absolute;
  width: 100%;
  bottom: 15px;
  top: 90px;
}
.ticket-more {
  width: 100%;
  padding: 20px;
}
.cell {
  background-color: #fff;
  border-radius: 2px;
  padding: 30px 55px;
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.149019607843137);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.149019607843137);
}
.bottom-button {
  text-align: right;
  width: 100%;
  padding: 25px;
}
</style>
